import { render, staticRenderFns } from "./ObjectPersonRules.vue?vue&type=template&id=f7094c10&scoped=true&"
import script from "./ObjectPersonRules.vue?vue&type=script&lang=js&"
export * from "./ObjectPersonRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7094c10",
  null
  
)

export default component.exports